import {ReactNode} from 'react';
import {Loading} from '../../../design-system/atoms/Loading/Loading';
import {useWelcomeQuery} from '../../../wrapper/storeWrapper';

export interface WelcomeFetcherProps {
  children: ReactNode;
}

export function WelcomeFetcher({children}: WelcomeFetcherProps) {
  const {data, isLoading} = useWelcomeQuery();

  return (
    <>
      {isLoading && (
        <div className="flex-center-full">
          <Loading />
        </div>
      )}
      {!isLoading && !!data && children}
    </>
  );
}
